/**
 * Login screen copy by failure class.
 * Never display API `data.error` (e.g. "wrong password").
 */

export const LOGIN_AUTH_ERROR =
  "The email and password combination failed.";
export const LOGIN_SYSTEM_ERROR =
  "Something went wrong. Please try again.";
export const LOGIN_NETWORK_ERROR =
  "Network error. Please check your connection.";

const validationMessages = (validationErrors) => {
  if (!validationErrors || typeof validationErrors !== "object") {
    return [];
  }

  return Object.values(validationErrors)
    .map((messages) => {
      const list = Array.isArray(messages) ? messages : [messages];
      return list.find((message) => typeof message === "string" && message.trim());
    })
    .filter(Boolean);
};

export const getLoginFailureMessage = (error) => {
  if (!error) {
    return LOGIN_SYSTEM_ERROR;
  }

  const status = error.status || error.response?.status;
  const data = error.data || error.response?.data || {};

  if (
    error.message === "Network Error" ||
    (!status && !navigator.onLine)
  ) {
    return LOGIN_NETWORK_ERROR;
  }

  const fieldMessages = validationMessages(data.validationErrors);
  if (fieldMessages.length) {
    return fieldMessages.join(" ");
  }

  // Wrong password is 422 { error: "Wrong password" } with no field errors.
  // 400/401 stay in the same class. Never surface that raw API string.
  if (status === 400 || status === 401 || status === 422) {
    return LOGIN_AUTH_ERROR;
  }

  return LOGIN_SYSTEM_ERROR;
};
